import * as authActions from './authActions';
import * as vendorProfileActions from './vendorProfileActions';
import * as jobRequestActions from './jobRequestActions';
import * as commonActions from './commonActions';
import * as useraccountActions from './useraccountActions';
import * as manageUserActions from './manageUserActions';
import * as driverEmergencyActions from './driverEmergencyActions';

import { assign } from 'lodash';

export const ActionCreators = assign({},
  authActions, vendorProfileActions, jobRequestActions, commonActions, useraccountActions,manageUserActions, driverEmergencyActions
);



// WEBPACK FOOTER //
// ./src/actions/index.js